import DailyRecurrence from 'owa-service/lib/contract/DailyRecurrence';
import RecurrenceType from 'owa-service/lib/contract/RecurrenceType';
import RelativeMonthlyRecurrence from 'owa-service/lib/contract/RelativeMonthlyRecurrence';
import WeeklyRecurrence from 'owa-service/lib/contract/WeeklyRecurrence';
import { toJS } from 'mobx';
import {
    isDailyRecurrence,
    isMonthlyRecurrence,
    isWeeklyRecurrence,
} from 'owa-recurrence-utils/lib/checkRecurrenceTypes';

export default function updateRecurrenceIntervalInRecurrencePattern(
    recurrence: RecurrenceType,
    interval: number
): RecurrenceType {
    // make a copy with toJS to create new recurrence object, in order to
    // update the event in store.
    //
    // See https://mobx.js.org/refguide/tojson.html
    let newRecurrence = toJS(recurrence, {
        recurseEverything: true,
    });

    if (newRecurrence) {
        if (isDailyRecurrence(newRecurrence)) {
            (newRecurrence.RecurrencePattern as DailyRecurrence).Interval = interval;
        } else if (isWeeklyRecurrence(newRecurrence)) {
            (newRecurrence.RecurrencePattern as WeeklyRecurrence).Interval = interval;
        } else if (isMonthlyRecurrence(newRecurrence)) {
            (newRecurrence.RecurrencePattern as RelativeMonthlyRecurrence).Interval = interval;
        }
    }

    return newRecurrence;
}
